'use strict';
(function () {

  var module = angular.module('client.directives');

  module.directive('elementStandards', ['standardsService',
    function (standardsService) {
      function link(scope, element, attrs) {
        scope.elementStandards = [];
        scope.selectedBreakouts = [];

        function sortByLevel(a, b, level) {
          var aCode = a.expectation_code.split('.');
          var bCode = b.expectation_code.split('.');
          if (aCode[level] && bCode[level]) {
            var aNum = parseInt(aCode[level], 10);
            var bNum = parseInt(bCode[level], 10);

            // parseint returns Nan if not a number so check both before comparing
            if (!isNaN(aNum) && !isNaN(bNum)) {
              if (aNum !== bNum) {
                return aNum - bNum;
              }
              else {
                return sortByLevel(a, b, level + 1);
              }
            }
            else {
              var stringComp = aCode[level].localeCompare(bCode[level]);
              if (stringComp !== 0) {
                return stringComp;
              }
              else {
                return sortByLevel(a, b, level + 1);
              }
            }
          }
          else {
            return 0;   // If invalid level then return equal
          }
        }

        function sortStandards(standards) {
          // Sort recursing down each level
          return standards.sort(function (a, b) {
            return sortByLevel(a.expectation, b.expectation, 0);
          });
        }

        standardsService.elementExpectations(scope.templateId, scope.elementId, scope.standardSetId, scope.gradeId).$promise
          .then(function (expectations) {
            scope.elementStandards = sortStandards(expectations).filter(function (expectation, index, self) {
              return index === self.findIndex(function (exp) {
                return exp.expectation.id === expectation.expectation.id;
              });
            });
        });

        scope.onSelectStandard = function (standard) {
          scope.selectedStandard = standard;
          scope.selectedBreakouts = standard.breakouts;
        };

        scope.FormatBreakout = function (standard, breakout) {
          if (standard && breakout) {
            var codeIndex = breakout.breakout_code.split(".").pop();
            return "<strong>" + standard.expectation.expectation_code + "</strong>&nbsp;&nbsp;" + "(" + codeIndex + ") " + breakout.breakout_label;
          }
        };

      }

      return {
        replace: true,
        restrict: 'E',
        template: require("./elementStandards.jade"),
        link: link,
        scope: {
          standardSetId: '=',
          standardSetLabel: '=',
          templateId: '=',
          elementId: '=',
          gradeId: '=',
        }
      };

    }]);
})();
